import { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "dino-lang";
const DEFAULT_LANG = "en";

const LanguageContext = createContext({
    lang: DEFAULT_LANG,
    setLang: () => {},
    toggleLang: () => {},
});

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try {
            const stored = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
            if (stored === "en" || stored === "de") return stored;
        } catch (_e) {
            // localStorage unavailable
        }
        return DEFAULT_LANG;
    });

    useEffect(() => {
        if (typeof document !== "undefined") document.documentElement.lang = lang;
    }, [lang]);

    const setLang = useCallback((next) => {
        setLangState(next);
        try {
            window.localStorage.setItem(STORAGE_KEY, next);
            document.documentElement.lang = next;
        } catch (_e) {
            // ignore
        }
    }, []);

    const toggleLang = useCallback(() => {
        setLang(lang === "en" ? "de" : "en");
    }, [lang, setLang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggleLang }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}

/**
 * Tiny helper: picks the localized version of an object shaped { en: ..., de: ... }
 */
export function pick(dict, lang) {
    if (!dict) return null;
    return dict[lang] ?? dict.en;
}
